import React from 'react';

const featureEnabled = (key) => document.documentElement.dataset[key] === 'true';

export const FeatureFlipContext = React.createContext({
  coSchedulingEnabled: featureEnabled('isCoschedulingEnabled'),
  coschedulingPriceUpdateEnabled: featureEnabled('isCoschedulingPriceUpdateEnabled'),
});
